import {
  type AudioMixer,
  connectCentralAudioToMixer,
} from '@/shared-utilities';

export function wireAudioElementIntoMixerGraph({
  audioMixerRef,
  centralAudioElement,
  isAiVoiceEnabled,
}: {
  audioMixerRef: React.RefObject<AudioMixer | null>;
  centralAudioElement: HTMLAudioElement | null;
  isAiVoiceEnabled: boolean;
}): void {
  if (!audioMixerRef.current || !centralAudioElement || !isAiVoiceEnabled) {
    return;
  }

  connectCentralAudioToMixer(audioMixerRef.current, centralAudioElement);
}
